import VueRouter from 'vue-router'
import ArticleLists from '@/views/article/lists.vue'
import ArticleContent from '@/views/article/content.vue'

// Keep FAQ navigation available without fetching additional JS/CSS chunks.
// import App from "../App"
const routes = [
    // {
    //     path: '/',
    //     name: 'index',
    //     component: () => import('@/views/about.vue'),
    // },
    {
        path: '/',
        name: 'ArticleLists',
        component: ArticleLists,
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about.vue'),
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact.vue'),
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/views/privacy.vue'),
    },
    {
        path: '/privacy-funlove-social',
        name: 'privacy-funlove-social',
        component: () => import('@/views/privacy-funlove-social.vue'),
    },
    {
        path: '/privacy-funlove-software',
        name: 'privacy-funlove-social',
        component: () => import('@/views/privacy-funlove-software.vue'),
    },
    {
        path: '/protocol',
        name: 'protocol',
        component: () => import('@/views/protocol.vue')
    },
    {
        path: '/protocol-funlove-social',
        name: 'protocol-funlove-social',
        component: () => import('@/views/protocol-funlove-social.vue')
    },
    {
        path: '/protocol-funlove-software',
        name: 'protocol-funlove-software',
        component: () => import('@/views/protocol-funlove-software.vue')
    },
    {
        path: '/exchange',
        name: 'exchange',
        component: () => import('@/views/exchange.vue')
    },
    {
        path: '/rechargePolicy',
        name: 'rechargePolicy',
        component: () => import('@/views/rechargePolicy.vue')
    },
    {
        path: '/article',
        name: 'ArticleLists',
        component: ArticleLists
    },
    {
        path: '/content/tag/:tag',
        name: 'ArticleTagContent',
        component: ArticleContent
    },
    {
        path: '/content/:id/:type',
        name: 'ArticleContent',
        component: ArticleContent
    },

]

const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    // history模式
    mode: 'hash'
})
export default router
